import React from 'react';

import { DEFAULT_ICON_PROPS, IIconProps } from '../constants';

export const StructureIcon = ({
  ariaLabel = 'Map waypoint icon for underwater structure',
  ...props
}: IIconProps) => {
  const { size, width, height, title, ariaHidden, className } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={size || width}
      height={size || height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      className={`block ${className}`}
      {...props}
    >
      {title && <title>{title}</title>}

      <rect x="0.726562" width="32" height="32" rx="16" fill="#E9F8FF" />
      <path
        d="M16.7266 6.78125C20.5963 6.78125 23.7578 10.0269 23.7578 14.0608C23.7578 17.106 21.9774 19.9028 20.1268 21.9771C19.2083 23.0066 18.2885 23.8403 17.5981 24.4166C17.2532 24.7045 16.9664 24.9273 16.7669 25.0776C16.7545 25.0869 16.7424 25.096 16.7307 25.1047C16.718 25.0949 16.7049 25.0848 16.6913 25.0743C16.4914 24.9195 16.2043 24.6903 15.8591 24.3955C15.168 23.8052 14.2473 22.9547 13.3279 21.9136C11.4738 19.8138 9.69531 17.0175 9.69531 14.0608C9.69531 10.0269 12.8568 6.78125 16.7266 6.78125Z"
        fill="#836651"
        stroke="white"
        strokeWidth="0.9375"
      />
      <mask
        id="mask0_187_17379"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="11"
        y="8"
        width="11"
        height="15"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.7411 8.66541C19.6349 8.66541 21.9798 11.0892 21.9798 14.0775C21.9798 18.5759 16.7411 22.1987 16.7411 22.1987C16.7411 22.1987 11.5024 18.4541 11.5024 14.0775C11.5024 11.0892 13.8473 8.66541 16.7411 8.66541Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_187_17379)">
        <path
          d="M23.8367 18.0116L20.4806 15.1375L18.8123 16.3126L17.3463 14.8404L15.3458 16.9916L13.3012 14.7347L9.91162 16.2287"
          stroke="white"
          strokeWidth="1.25"
          strokeLinecap="square"
        />
      </g>
    </svg>
  );
};
